import { Table2 } from "lucide-react";

// First 4 letters; on clashes use first 3 letters + first letter after the space.
export const abbreviate = (players) => {
  const base = (n) => n.trim().slice(0, 4);
  const counts = {};
  players.forEach((p) => { const b = base(p.name).toLowerCase(); counts[b] = (counts[b] || 0) + 1; });
  const used = {};
  return Object.fromEntries(players.map((p) => {
    const n = p.name.trim();
    let a = base(n);
    if (counts[a.toLowerCase()] > 1) {
      const after = n.split(/\s+/)[1]?.[0];
      a = n.slice(0, 3) + (after ? after.toLowerCase() : "");
    }
    used[a] = (used[a] || 0) + 1;
    return [p.user_id, used[a] > 1 ? `${a}${used[a]}` : a];
  }));
};

const HIT = "bg-emerald-500/25 text-emerald-300 font-bold";
const label = (m) => `${m.home} ${m.away}`;
const score = (m) => (m.score_home != null && ["FINISHED", "IN_PLAY", "PAUSED"].includes(m.status) ? `${m.score_home}-${m.score_away}` : "");

export const PicksGrid = ({ slips }) => {
  const { matches, players } = slips;
  const abbr = abbreviate(players);
  const pick = Object.fromEntries(players.map((p) => [p.user_id, Object.fromEntries(p.picks.map((x) => [x.match_id, x]))]));
  const exactRows = matches.filter((m) => players.some((p) => pick[p.user_id][m.match_id]?.exact_home != null));
  const th = "px-1.5 py-1 font-mono text-[10px] uppercase tracking-wider text-slate-400";
  const td = "px-1.5 py-1 text-center font-mono text-xs whitespace-nowrap border-l border-[#26334D]/60";
  const matchCell = (m) => (
    <td className="sticky left-0 bg-[#121824] px-2 py-1 font-mono text-xs font-bold whitespace-nowrap">
      {label(m)} <span className="text-slate-500 font-normal">{score(m)}</span>
    </td>
  );

  return (
    <div className="card-surface p-3 space-y-2" data-testid="picks-grid">
      <h3 className="font-display text-lg font-bold uppercase flex items-center gap-2"><Table2 size={18} className="text-emerald-400" /> Tabella pronostici</h3>
      <div className="overflow-x-auto">
        <table className="text-sm border-collapse">
          <thead>
            <tr className="border-b border-[#26334D]">
              <th className={`${th} sticky left-0 bg-[#121824] text-left`}>Partita</th>
              {players.map((p) => <th key={p.user_id} title={p.name} className={`${th} border-l border-[#26334D]/60`} data-testid={`grid-player-${p.user_id}`}>{abbr[p.user_id]}</th>)}
            </tr>
          </thead>
          <tbody>
            {matches.map((m) => (
              <tr key={m.match_id} className="border-b border-[#26334D]/40" data-testid={`grid-row-${m.match_id}`}>
                {matchCell(m)}
                {players.map((p) => {
                  const x = pick[p.user_id][m.match_id];
                  return <td key={p.user_id} className={`${td} ${x?.result?.correct ? HIT : "text-slate-200"}`}>{x?.pick || ""}</td>;
                })}
              </tr>
            ))}
            {exactRows.length > 0 && (
              <tr className="border-y border-[#26334D]"><td colSpan={players.length + 1} className="sticky left-0 px-2 pt-3 pb-1 font-mono text-[10px] uppercase tracking-widest text-violet-400">Ris. esatti</td></tr>
            )}
            {exactRows.map((m) => (
              <tr key={`ex-${m.match_id}`} className="border-b border-[#26334D]/40" data-testid={`grid-exact-row-${m.match_id}`}>
                {matchCell(m)}
                {players.map((p) => {
                  const x = pick[p.user_id][m.match_id];
                  const has = x?.exact_home != null;
                  return <td key={p.user_id} className={`${td} ${has && x.result?.exact ? HIT : "text-slate-200"}`}>{has ? `${x.exact_home} ${x.exact_away}` : ""}</td>;
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
